module.exports = __webpack_public_path__ + "img/mobile.a184b911.png";